import { CaseRegionFilterOptions } from '../../enums/filters-and-searchs/caseregion.filter.options';


export const CaseRegionFilterOptionsDetail = new Map<number, string>([
    [CaseRegionFilterOptions.None, 'None'],
    [CaseRegionFilterOptions.DeletedCaseRegions, 'Deleted Case Regions'],
]);